import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const reputations = [
  {
    rating: 5,
    name: '追剧达人小王',
    content: '窝窝影院真的太棒了！不卡顿画质还清晰，每天都有新剧更新。我用了快半年了，从来没有收过一分钱，完全免费！强烈推荐给所有追剧的朋友。',
    date: '2026年7月',
  },
  {
    rating: 5,
    name: '影迷小李',
    content: '之前用其他平台总是有各种广告弹窗，烦死了。窝窝影院完全没广告，观影体验超级好。分类也很清晰，找剧特别方便。',
    date: '2026年6月',
  },
  {
    rating: 5,
    name: '宅女柚子',
    content: '日剧资源特别全！很多冷门日剧都能找到，而且更新速度超快。画质流畅，晚上看剧一点也不卡，好评！',
    date: '2026年7月',
  },
  {
    rating: 4,
    name: '动漫迷阿杰',
    content: '动漫分类做得很好，最新的番剧基本都有。清晰度很高，加载也快。希望能加入弹幕功能就更完美了！',
    date: '2026年5月',
  },
  {
    rating: 5,
    name: '韩剧控小美',
    content: '作为一个韩剧死忠粉，窝窝影院的韩剧资源真的让我惊喜。更新跟韩国差不多同步，翻译质量也很高。感恩有这么好的免费平台！',
    date: '2026年7月',
  },
  {
    rating: 5,
    name: '上班族老陈',
    content: '通勤路上用手机看剧打发时间，发现窝窝影院在手机上体验也特别好。界面简洁，操作方便，加载速度快。',
    date: '2026年6月',
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-20 pb-16">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>

          {/* Hero */}
          <section className="text-center py-12 md:py-16 mb-10">
            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-movie-2-line text-white text-3xl w-10 h-10 flex items-center justify-center"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              关于窝窝影院
            </h1>
            <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              窝窝影院是一个致力于为用户提供免费高清电视剧在线观看的平台。
              我们相信，好的内容应该让所有人都能轻松获取。
            </p>
          </section>

          {/* Stats */}
          <section className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
            {[
              { value: '5000+', label: '剧集资源' },
              { value: '99%', label: '用户好评' },
              { value: '24h', label: '每日更新' },
              { value: '0元', label: '完全免费' },
            ].map((stat, idx) => (
              <div key={idx} className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
                <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </section>

          {/* Brand Introduction */}
          <section id="brand" className="mb-16 max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
              品牌介绍
            </h2>
            <div className="p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70">
              <div className="text-sm text-foreground-700 leading-relaxed space-y-4">
                <p>
                  窝窝影院成立于2023年，是一家专注于提供免费电视剧在线观看服务的互联网平台。
                  我们的使命是让每一位追剧爱好者都能以最便捷的方式、最流畅的体验观看到他们喜爱的电视剧内容。
                </p>
                <p>
                  自成立以来，窝窝影院始终坚持"免费、高清、无广告"的核心服务理念。我们投入大量资源优化视频播放技术，
                  确保用户无论使用何种设备、何种网络环境，都能获得流畅不缓冲的观影体验。
                </p>
                <p>
                  窝窝影院的内容涵盖<strong>国产剧、韩剧、美剧、日剧、动漫</strong>等各大品类，
                  并与时俱进地追踪最新热播剧集，确保每日更新，第一时间为用户送上精彩内容。
                </p>
                <p>
                  我们拥有一支充满热情的专业团队，包括内容编辑、技术开发、产品设计等各方面的人才。
                  团队成员都是资深的追剧爱好者，我们比任何人都更理解用户的需求和期待。
                </p>
                <p>
                  窝窝影院的愿景是成为华语地区最受欢迎的免费追剧平台。我们将持续优化产品体验，
                  丰富内容资源，为更多用户带来优质的在线观影享受。
                </p>
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section id="reputation" className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {reputations.map((rep, idx) => (
                <div
                  key={idx}
                  className="p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i
                        key={i}
                        className={`w-4 h-4 flex items-center justify-center ${
                          i < rep.rating
                            ? 'ri-star-fill text-secondary-500'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;{rep.content}&rdquo;
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-foreground-800">{rep.name}</span>
                    <span className="text-xs text-foreground-500">{rep.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="mb-16 max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">电子邮箱</h3>
                <p className="text-xs text-foreground-600">contact@wowocinema.com</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-accent-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">微信公众号</h3>
                <p className="text-xs text-foreground-600">窝窝影院官方</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-customer-service-line text-secondary-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">在线客服</h3>
                <p className="text-xs text-foreground-600">工作日 9:00-18:00</p>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section id="faq" className="mb-16 max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
              常见问题
            </h2>
            <div className="space-y-3">
              {[
                { q: '窝窝影院真的完全免费吗？', a: '是的！窝窝影院承诺永久免费。所有电视剧资源全部免费在线观看，无需付费、无需注册、无需登录。' },
                { q: '为什么没有任何广告？', a: '窝窝影院坚持无广告的纯净观影体验。我们通过技术优化和成本控制来实现平台的可持续运营，将最好的体验留给用户。' },
                { q: '电视剧画质怎么样？', a: '窝窝影院采用先进的视频编码技术和CDN加速网络，确保高清画质下的流畅播放。大部分剧集支持1080P超清画质。' },
                { q: '更新速度跟得上吗？', a: '我们的内容团队每日跟进各平台的最新剧集更新，热门剧集基本能做到与官方平台同步更新，让你第一时间追到最新内容。' },
                { q: '可以在手机上观看吗？', a: '完全可以！窝窝影院的网站采用响应式设计，完美适配手机、平板和电脑等各类设备。无论你在哪里，打开浏览器就能看。' },
              ].map((faq, idx) => (
                <details key={idx} className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
                    <h3 className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</h3>
                    <i className="ri-add-line text-foreground-400 group-open:hidden w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:flex w-4 h-4 items-center justify-center flex-shrink-0"></i>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于窝窝影院',
            description: '窝窝影院是一个致力于为用户提供免费高清电视剧在线观看的平台。',
            url: 'https://wowocinema.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '窝窝影院',
              url: 'https://wowocinema.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: '窝窝影院真的完全免费吗？', acceptedAnswer: { '@type': 'Answer', text: '是的！窝窝影院承诺永久免费。所有电视剧资源全部免费在线观看，无需付费、无需注册、无需登录。' } },
              { '@type': 'Question', name: '为什么没有任何广告？', acceptedAnswer: { '@type': 'Answer', text: '窝窝影院坚持无广告的纯净观影体验。我们通过技术优化和成本控制来实现平台的可持续运营，将最好的体验留给用户。' } },
              { '@type': 'Question', name: '电视剧画质怎么样？', acceptedAnswer: { '@type': 'Answer', text: '窝窝影院采用先进的视频编码技术和CDN加速网络，确保高清画质下的流畅播放。大部分剧集支持1080P超清画质。' } },
              { '@type': 'Question', name: '更新速度跟得上吗？', acceptedAnswer: { '@type': 'Answer', text: '我们的内容团队每日跟进各平台的最新剧集更新，热门剧集基本能做到与官方平台同步更新。' } },
              { '@type': 'Question', name: '可以在手机上观看吗？', acceptedAnswer: { '@type': 'Answer', text: '完全可以！窝窝影院的网站采用响应式设计，完美适配手机、平板和电脑等各类设备。' } },
            ],
          }),
        }}
      />
    </div>
  );
}